import { render, staticRenderFns } from "./TheGerman.vue?vue&type=template&id=6f5945af&"
import script from "./TheGerman.vue?vue&type=script&lang=js&"
export * from "./TheGerman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports